import { render, staticRenderFns } from "./assessment-desktop.vue?vue&type=template&id=4005ebe9&scoped=true&"
import script from "./assessment-desktop.vue?vue&type=script&lang=ts&"
export * from "./assessment-desktop.vue?vue&type=script&lang=ts&"
import style0 from "./assessment-desktop.vue?vue&type=style&index=0&id=4005ebe9&lang=scss&scoped=true&"
import style1 from "./assessment-desktop.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4005ebe9",
  null
  
)

export default component.exports